<template>
  <vue-modal
    :maxWidth="700"
    :minWidth="300"
    adaptive
    classes="vue-modal-container"
    height="auto"
    name="partner-finder-profile-modal"
    scrollable
    width="500px"
    @before-open="beforeModalOpen"
  >
    <div class="header">
      <h3>{{ trans.title }}</h3>
      <div class="subj">{{ subject_type }}</div>
    </div>
    <div class="content">
      <div class="ui form">
        <div class="">
          <label for="userActive">Aktív</label>
          <div class="switch largex">
            <input
              id="userActive"
              v-model="active"
              :true-value="true"
              class="switch-input"
              type="checkbox"
            />
            <label class="switch-paddle"
                   for="userActive">
              <span aria-hidden="true"
                    class="switch-active">I</span>
              <span aria-hidden="true"
                    class="switch-inactive">N</span>
            </label>
          </div>
        </div>

        <div v-if="!active"
             class='inactive-hider'>
          Nem veszek részt a Club-ban
        </div>
        <div v-else>
          <label v-if="!phone">{{ trans.phone_required }}</label>
          <div v-if="!phone"
               class="block">
            <vue-tel-input
              v-model="newPhoneNumber"
              :placeholder="trans.phone_placeholder"
              defaultCountry="HU"
              @onInput="phoneUpdate"
            ></vue-tel-input>
          </div>

          <label>{{ trans.self_rank }}</label>
          <div class="block">
            <div class="slider-outer">
              <a
                v-for="val in rank_values"
                :key="val.id"
                :class="{ active: self_rank == val.id }"
                class="slider-item"
                @click="self_rank = val.id"
              >{{ val.name }}</a
              >
            </div>
          </div>

          <div class="block">
            <label>{{ trans.self_tryhard }}</label
            ><br/>

            <div class="slider-outer">
              <a
                v-for="val in tryhard_values"
                :key="val.id"
                :class="{ active: self_tryhard == val.id }"
                class="slider-item"
                @click="self_tryhard = val.id"
              >{{ val.name }}</a
              >
            </div>
          </div>
          <div v-if="policy_accept_needed">
            <div class="policy"
                 v-html="trans.adatkezelesi"></div>
            <div class="">
              <label for="policy_accepted"
              >Elfogadom az adatkezelési tájékoztatót</label
              >
              <div class="switch largex">
                <input
                  id="policy_accepted"
                  v-model="policy_accepted"
                  :true-value="true"
                  class="switch-input"
                  type="checkbox"
                />
                <label class="switch-paddle"
                       for="policy_accepted">
                  <span aria-hidden="true"
                        class="switch-active">I</span>
                  <span aria-hidden="true"
                        class="switch-inactive">N</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ui button"
              @click="close()">Mégsem
      </button>
      <button
        :disabled="
          active && (
            (policy_accept_needed && !policy_accepted) ||
            (!isNewPhoneNumberValid)
          )
        "
        class="ui primary button"
        @click="save()"
      >
        Mentés
      </button>
    </div>
  </vue-modal>
</template>
<script>
import {mapState} from 'vuex';
import VueTelInput from 'vue-tel-input';
import notify from '../../notify';
import {doSaveProfile} from '../../store/partnerFinder';

export const MODAL = 'partner-finder-profile-modal';

export default {
  components: {
    VueTelInput,
  },
  data () {
    return {
      active: false,
      self_rank: 1,
      self_tryhard: 1,
      rank_values: [],
      tryhard_values: [],
      policy_accepted: false,
      policy_accept_needed: true,
      subject_type: '-no-subject-type-',
      isNewPhoneNumberValid: false,
      newPhoneNumber: null,
    };
  },
  computed: {
    ...mapState({
      trans: (state) => state.trans.partnerFinderProfileModal,
      phone: (state) => (state.user ? state.user.phone : null),
    }),
  }, // computed

  methods: {
    beforeModalOpen (/*event*/) {
      let pf =
        this.$store.state.partnerFinder.userProfiles[
        this.$store.state.currentClientDomain +
        '__' +
        this.$store.state.currentSubjectTypeID
          ];
      if (pf) {
        this.self_rank = pf.self_rank;
        this.self_tryhard = pf.self_tryhard;
        this.policy_accepted = pf.active;
        this.policy_accept_needed = !pf.active;
        this.active = true;
      } else {
        this.active = true;
        this.self_rank = 1;
        this.self_tryhard = 1;
        this.policy_accepted = false;
        this.policy_accept_needed = true;
      }
      this.subject_type = this.$store.state.subjectTypes.find(
        (a) => a.ID == this.$store.state.currentSubjectTypeID,
      ).subjectType;
      this.isNewPhoneNumberValid = !!this.phone;
    },
    close () {
      this.$modal.hide(MODAL);
    },
    save () {
      let data = {
        subject_type_id: this.$store.state.currentSubjectTypeID,
        policy_accepted: this.policy_accepted,
        active: this.active,
        self_rank: this.self_rank,
        self_tryhard: this.self_tryhard,
        phone: this.newPhoneNumber,
      };
      this.$store.dispatch(doSaveProfile, data).then((response) => {
        this.$modal.hide(MODAL);
        notify.success(response.body.msg);
      });
    },
    // eslint-disable-next-line
    phoneUpdate ({ number, isValid, country }) {
      this.isNewPhoneNumberValid = isValid;
    },
  }, // methods
  created () {
    this.rank_values = [];
    for (let i in this.trans.rank_values) {
      this.rank_values.push({
        id: parseInt(i) + 1,
        name: this.trans.rank_values[i],
      });
    }
    this.tryhard_values = [];
    for (let i in this.trans.tryhard_values) {
      this.tryhard_values.push({
        id: parseInt(i) + 1,
        name: this.trans.tryhard_values[i],
      });
    }
  },
};
</script>

<style scoped>
.block {
  padding-bottom: 1em;
}

.actions {
  padding-top: 2em;
  display: flex;
  justify-content: space-between;
}

.slider-outer {
  display: flex;
  justify-content: space-between;
}

.slider-item {
  display: block;
  flex: 1 1 auto;
  cursor: pointer;
  color: inherit;
  /*border-radius: 0.3rem;*/
  padding: 4px 0;
  background-color: #f0f0f0;
  text-align: center;
}

.slider-item:hover {
  background-color: #ddd;
}

.slider-item.active {
  background-color: #2185d0;
  color: #fff;
}

.policy {
  background-color: #f0f0f0;
  padding: 1em;
  border-radius: 0.5em;
  overflow-y: scroll;
  max-height: 18em;
  margin-bottom: 1em;
}

.header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding-bottom: 0;
}

.subj {
  color: #888;
}

.inactive-hider {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}
</style>
